import React, { useEffect, useState } from "react";
import "./allcareanddare.css";

const BASE_API_URL =
  "https://cms.gammadda.lk/wp-json/wp/v2/posts?categories=17&per_page=9&_embed";

const AllCareAndDare = () => {
  const [projects, setProjects] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [lang, setLang] = useState("en");

  const fetchProjects = async (pageNumber) => {
    try {
      setLoading(true);
      const response = await fetch(`${BASE_API_URL}&page=${pageNumber}`);
      if (!response.ok) {
        if (response.status === 400 || response.status === 404) {
          setHasMore(false);
        }
        return;
      }

      const data = await response.json();
      if (data.length > 0) {
        setProjects((prevProjects) => [
          ...prevProjects,
          ...data.filter(
            (newPost) =>
              !prevProjects.some((oldPost) => oldPost.id === newPost.id)
          ),
        ]);
        setPage(pageNumber);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProjects(1);

    const detectLanguage = () => {
      const el = document.querySelector(".nav-link");
      if (!el) return;

      const text = el.innerText;
      if (/[඀-෿]/.test(text)) {
        setLang("si"); // Sinhala
      } else if (/[஀-௿]/.test(text)) {
        setLang("ta"); // Tamil
      } else {
        setLang("en"); // Default
      }
    };

    const observer = new MutationObserver(detectLanguage);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    detectLanguage();

    return () => observer.disconnect();
  }, []);

  const loadMore = () => {
    if (!loading && hasMore) {
      fetchProjects(page + 1);
    }
  };

  const getImageUrl = (post) => {
    if (
      post._embedded &&
      post._embedded["wp:featuredmedia"] &&
      post._embedded["wp:featuredmedia"][0]
    ) {
      return post._embedded["wp:featuredmedia"][0].source_url;
    }
    return "default-image.jpg";
  };

  const subtitleStyle = {
    fontSize: lang === "si" ? "25px" : lang === "ta" ? "20px" : "42px",
    textDecoration: "none",
    color: "black",
  };

  return (
    <div id="projects" className="section-copy d-flex justify-content-center">
      <div
        className="container mx-2"
        style={{ paddingTop: "70px", maxWidth: "940px" }}
      >
        <div className="projects-title-wrapper d-flex justify-content-between align-items-center">
          <h2 className="projects-left lu---heading-2" style={subtitleStyle}>
            Care &amp; Dare
          </h2>
        </div>
        <div className="row">
          {projects.length > 0 ? (
            projects.map((post) => (
              <div className="col-md-4 col-sm-6 col-12 mb-3" key={post.id}>
                <div className="card card-latest">
                  <img
                    src={getImageUrl(post)}
                    className="card-img-top"
                    alt={post.title.rendered}
                  />
                  <div className="card-body">
                    <h5 className="card-title">
                      {post.title.rendered.replace(/&#038;/g, "&")}
                    </h5>
                    <a
                      href={`/news/${post.slug}`}
                      className="d-flex justify-content-center gm---heading-3"
                      style={{ textDecoration: "none", color: "#f94322" }}
                    >
                      View Project
                    </a>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>Loading projects...</p>
          )}
        </div>

        {hasMore && projects.length > 0 && (
          <div className="text-center my-4">
            <button
              className="btn load-more-button"
              onClick={loadMore}
              disabled={loading}
            >
              {loading ? "Loading..." : "Load More"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AllCareAndDare;
